<script setup lang="ts">
/**
 * Tauri 未登录欢迎门。账号与试用资格统一由线下工作人员收集资料、运营审核开通，
 * 此处只保留已有账号登录，不提供自助开户入口。
 */
import { useAuthModal } from '@/composables/useAuthModal'

const { openAuth } = useAuthModal()
</script>

<template>
  <div class="welcome">
    <div class="welcome-card">
      <span class="welcome-badge"><i class="ti ti-photo-search" aria-hidden="true"></i></span>
      <h2 class="welcome-title">欢迎使用面料档口管理台</h2>
      <p class="welcome-sub">请使用工作人员为你开通的账号登录。</p>
      <button class="wbtn wbtn-primary" type="button" @click="openAuth()">
        <i class="ti ti-login-2" aria-hidden="true"></i> 登录
      </button>
      <p class="welcome-hint">试用与正式开通均由工作人员核验资料后统一安排。</p>
    </div>
  </div>
</template>

<style scoped>
.welcome {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.welcome-card {
  text-align: center;
  max-width: 420px;
}
.welcome-badge {
  width: 56px;
  height: 56px;
  border-radius: var(--border-radius-lg);
  background: var(--color-brand);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin-bottom: 16px;
}
.welcome-title {
  font-size: var(--fs-stat, 22px);
  font-weight: var(--fw-bold);
  color: var(--color-text-primary);
  margin: 0 0 8px;
}
.welcome-sub {
  font-size: var(--fs-body, 14px);
  color: var(--color-text-secondary);
  line-height: 1.6;
  margin: 0 0 22px;
}
.wbtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  font-size: var(--fs-item);
  font-weight: var(--fw-med);
  border-radius: var(--border-radius-md);
  border: var(--border-width-control) solid var(--color-brand);
  background: var(--color-brand);
  color: #fff;
  cursor: pointer;
  font-family: inherit;
}
.wbtn:hover {
  filter: brightness(1.06);
}
.welcome-hint {
  font-size: var(--fs-label);
  color: var(--color-text-tertiary);
  margin-top: 18px;
}
</style>
